<template>
  <div
    class="media-item"
    :class="{'has-error': error}"
  >
    <div class="media">
      <div class="media-left">
        <component
          :is="url ? 'a' : 'div'"
          :href="url"
          target="_blank"
          class="media-image"
        >
          <img
            v-if="imageUrl"
            :src="imageUrl"
            :alt="name"
          >
          <span v-else>{{ extension }}</span>
        </component>
      </div>
      <div class="media-content">
        <div class="leading-normal">
          <p class="truncate">
            {{ name }}
          </p>
          <p>
            {{ size }}
          </p>
          <button
            type="button"
            class="button is-small is-underline"
            @click="$emit('deleteClick')"
          >
            {{ $t('remove').capitalize() }}
          </button>
        </div>
      </div>
    </div>
    <p
      v-if="error"
      class="help is-danger"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      default: null,
      type: String
    },
    file: {
      required: true,
      validator (i) {
        return i instanceof Object || i instanceof File;
      }
    }
  },
  data () {
    return {
      blob: null
    };
  },
  computed: {
    name () {
      if (this.file.file_name) {
        return this.file.file_name;
      }
      return this.file.name;
    },
    size () {
      return this.file.size.fileSizeFormat();
    },
    fullType () {
      let type = "file";

      if (this.file.mime_type) {
        type = this.file.mime_type;
      }

      if (this.file.type) {
        type = this.file.type;
      }

      return type;
    },
    type () {
      let parts = this.fullType.split("/");
      return parts[0];
    },
    extension () {
      let parts = this.fullType.split("/");
      return parts[parts.length - 1];
    },
    url () {
      if (this.file.url) {
        return this.file.url;
      }
      return null;
    },
    imageUrl () {
      if (this.type == "image") {
        if (this.url) {
          return this.url;
        }
        if (this.blob) {
          return this.blob;
        }
      }
      return null;
    }
  },
  watch: {
    file: {
      handler () {
        this.blob = null;

        if (this.file instanceof File) {
          var reader = new FileReader();
          reader.readAsDataURL(this.file);
          reader.onload = () => {
            this.blob = reader.result;
          };
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>

@import "~/scss/variables";

.media-item {
  border: 1px $grey-lighter solid;
  border-radius: $radius;
  padding: 1rem;
  overflow: hidden;
  margin-top: 1rem;

  &.has-error {
    background-color: rgba(220, 38, 38, 0.1);
    border-color: $danger;
  }
}

.media-image {
  height: 72px;
  width: 72px;
  border: 1px $grey-lighter solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: $grey-darker;
  border-radius: 2px;
  background-color: $white-bis;
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
